import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SoldierList from './SoldierList';
import { SaveButton } from 'components/buttons';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class AbsenteeModal extends Component {

  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    soldiers: PropTypes.array.isRequired,
    saveAbsentees: PropTypes.func.isRequired,
  };

  state = {
    soldiers: [],
    saving: false
  };

  componentDidUpdate({ isOpen }){
    if ( isOpen !== this.props.isOpen )
      this.setState({ soldiers: this.props.soldiers });
  }

  toggleSoldier = user_id => e => {
    const soldiers = this.state.soldiers.map(
      soldier => soldier.user_id === user_id
        ? { ...soldier, absent: !e.target.checked }
        : soldier
    );
    this.setState({ soldiers });
  }

  onSubmit = e => {
    e.preventDefault();
    this.setState({ saving: true });

    Promise.resolve( this.props.saveAbsentees( this.state.soldiers ) )
    .then( () => this.setState({ saving: false }) )
    .catch( () => this.setState({ saving: false }) );
  }

  render(){
    let { isOpen, toggle } = this.props;
    let { soldiers, saving } = this.state;

    return (
      <Modal isOpen={ isOpen } toggle={ toggle } centered id='AbsenteeModal'>

        <ModalHeader toggle={ toggle }>
          Absentee list
        </ModalHeader>

        <form onSubmit={ this.onSubmit }>

          <ModalBody>

            <p>
              Turn off soldiers who are not in class. They stay on the grid,
              greyed out, and cannot be marked until you turn them back on.
            </p>

            <SoldierList
              soldiers={ soldiers }
              toggleSoldier={ this.toggleSoldier } />

          </ModalBody>

          <ModalFooter>

            <SaveButton saving={ saving } />

          </ModalFooter>

        </form>
      </Modal>
    );
  }
}

export default AbsenteeModal;



// WEBPACK FOOTER //
// ./src/pages/missions/mark/includes/AbsenteeModal.jsx